"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.renderFormField = exports.SimpleForm = void 0;
var React = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var Yup = _interopRequireWildcard(require("yup"));
var _semanticUiReact = require("semantic-ui-react");
var _reactFlexboxGrid = require("react-flexbox-grid");
var _FormComponents = require("./FormComponents");
var _FormField = require("./FormField");
var _MemoField = require("./MemoField");
var _reactRouter = require("react-router");
var _notNullOrUndefined = require("../utils/notNullOrUndefined");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function noop() {
  // no operation
}
function getValueOrDefault(intialValue, defaultValue) {
  if (intialValue != null && intialValue != undefined) {
    return intialValue;
  }
  if (defaultValue != null && defaultValue != undefined) {
    return defaultValue;
  }
  return "";
}
function getInitialValues(schema, values) {
  var initialValues = {};
  schema.forEach(function (x) {
    var fieldsInitial = [];
    if ((x.fieldArrayFields || x.fields) && x.component != _semanticUiReact.List) {
      if (x.fieldArrayFields) {
        if (!values || !values[x.props.name]) {
          var initialRowData = {};
          x.fieldArrayFields && x.fieldArrayFields.forEach(function (y) {
            if (y.component !== _semanticUiReact.Label && y.component !== _semanticUiReact.Header && y.component !== _semanticUiReact.List) {
              initialRowData[y.props.name] = y.props.defaultValue || "";
              fieldsInitial.push();
            }
          });
          fieldsInitial.push(initialRowData);
        } else {
          fieldsInitial = values[x.props.name];
        }
      }
      x.component === _FormComponents.SimpleFormFieldArray ? initialValues[x.props.name] = fieldsInitial : x.fields && x.fields.forEach(function (y) {
        if (y.component !== _semanticUiReact.Label && y.component !== _semanticUiReact.Header) {
          initialValues[y.props.name] = getValueOrDefault(values && values[y.props.name], y.props.defaultValue);
        }
      });
    } else {
      if (x.component !== _semanticUiReact.Label && x.component !== _semanticUiReact.Header && values && ![undefined, null].includes(values[x.props.name])) {
        initialValues[x.props.name] = values[x.props.name];
      }
    }
  });
  return initialValues;
}
var SimpleForm = exports.SimpleForm = /*#__PURE__*/function (_React$Component) {
  function SimpleForm() {
    _classCallCheck(this, SimpleForm);
    return _callSuper(this, SimpleForm, arguments);
  }
  _inherits(SimpleForm, _React$Component);
  return _createClass(SimpleForm, [{
    key: "render",
    value: function render() {
      var _this = this;
      var schema = this.props.formSchema.filter(_notNullOrUndefined.notNullOrUndefined);
      var validationSchema = {};
      schema.forEach(function (x) {
        if (x.fields) {
          x.fields.map(function (y) {
            if (y.validation) {
              validationSchema[y.props.name] = y.validation;
            }
          });
        } else {
          validationSchema[x.props.name] = x.validation;
        }
      });
      var initialValues = getInitialValues(schema, this.props.intialValues);

      //console.log(initialValues)
      return /*#__PURE__*/React.createElement("div", {
        className: this.props.className
      }, /*#__PURE__*/React.createElement(_formik.Formik, {
        initialValues: initialValues,
        validationSchema: Yup.object().shape(validationSchema),
        onSubmit: function onSubmit(values, actions) {
          Promise.resolve(_this.props.onSubmit(values, actions)).then(function (v) {
            actions.setSubmitting(false);
            actions.setTouched({});
            if (_this.props.resetOnSubmit === true || _this.props.resetOnSubmit === undefined) actions.resetForm(values);
          });
        },
        validateOnBlur: true,
        enableReinitialize: true,
        render: function render(_ref) {
          var isValidating = _ref.isValidating,
            isSubmitting = _ref.isSubmitting,
            submitForm = _ref.submitForm,
            dirty = _ref.dirty,
            values = _ref.values;
          return /*#__PURE__*/React.createElement(_semanticUiReact.Form, {
            novalidate: true,
            as: "div",
            loading: _this.props.loading,
            style: {
              position: "initial"
            }
          }, schema.map(function (x, indexX) {
            if (x.fields) {
              var Container = x.component;
              if (Container === _FormComponents.SimpleFormFieldArray) {
                var props = _objectSpread(_objectSpread({}, _this.props), x.props);
                return /*#__PURE__*/React.createElement(_reactFlexboxGrid.Row, {
                  key: indexX
                }, renderFormField(x.component, _this.props.disabled, _this.props.readonly || x.props.readonly, props, x.fields, x.fieldArrayFields));
              }
              return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_reactFlexboxGrid.Row, null, /*#__PURE__*/React.createElement(_reactFlexboxGrid.Col, null, /*#__PURE__*/React.createElement(_semanticUiReact.Segment, {
                style: {
                  paddingBottom: 0
                },
                basic: true
              }, /*#__PURE__*/React.createElement(_semanticUiReact.Header, {
                size: "small"
              }, x.label)))), /*#__PURE__*/React.createElement(Container, x.props, /*#__PURE__*/React.createElement(_reactFlexboxGrid.Row, null, x.fields && x.fields.map(function (y, indexY) {
                return /*#__PURE__*/React.createElement(_reactFlexboxGrid.Col, _extends({
                  key: indexY
                }, y.colSize), renderFormField(y.component || _FormField.FormField, _this.props.disabled, _this.props.readonly || y.props.readonly, _objectSpread(_objectSpread({}, y.props), {}, {
                  key: indexY
                })));
              }))));
            } else {
              return renderFormField(x.component || _FormField.FormField, _this.props.disabled, _this.props.readonly || x.props.readonly, _objectSpread(_objectSpread({}, x.props), {}, {
                key: indexX
              }));
            }
          }), /*#__PURE__*/React.createElement(_semanticUiReact.Segment, {
            basic: true,
            style: {
              padding: 0,
              margin: "10px 0px",
              position: "initial"
            }
          }, _this.props.renderSubmitButtons ? _this.props.renderSubmitButtons({
            disabled: isSubmitting || isValidating || !dirty,
            isValidating: isValidating,
            isSubmitting: isSubmitting,
            submitForm: submitForm,
            dirty: dirty,
            values: values
          }) : /*#__PURE__*/React.createElement(_semanticUiReact.Button, {
            secondary: true,
            onClick: submitForm,
            fluid: true,
            disabled: isSubmitting || isValidating || !dirty
          }, _this.props.submitText || "Submit")), /*#__PURE__*/React.createElement(_reactRouter.Prompt, {
            when: !_this.props.loading && dirty && !isSubmitting,
            message: "You have unsaved changes!"
          }));
        }
      }));
    }
  }]);
}(React.Component);
var renderFormField = exports.renderFormField = function renderFormField(component, disabled, readonly, props, fields, fieldArrayFields, value) {
  return /*#__PURE__*/React.createElement(_formik.Field, {
    key: props.key,
    name: props.name
  }, function (form) {
    props["onChange"] = readonly ? noop : form.form.handleChange;
    props["disabled"] = props["disabled"] || disabled;
    props["value"] = form.form.values[props.name] || value;
    props["setFieldValue"] = readonly ? noop : form.form.setFieldValue;
    props["error"] = form.form.errors[props.name] && form.form.touched[props.name] ? form.form.errors[props.name].toString() : undefined;
    props["fields"] = fields;
    props["fieldArrayFields"] = fieldArrayFields;
    if (readonly || props.prefill && !props.prefillonce) {
      props["readOnly"] = true;
    }
    return /*#__PURE__*/React.createElement(_MemoField.MemoField, _extends({
      component: component
    }, props));
  });
};